module.exports = __webpack_public_path__ + "static/media/FD.a9a87547.png";